module.exports = __webpack_public_path__ + "img/people.d222d721.svg";